import {tva} from "@gluestack-ui/nativewind-utils/tva";

const captionTableStyle = process.env.IS_WEB ? "caption-bottom" : "";

export const tableWrapperStyle = tva({
    base: "bg-white max-w-full overflow-x-auto shrink-0",
    variants: {
        visible: {
            true: "overflow-visible"
        }
    }
});

export const tableStyle = tva({
    base: "table w-full border-collapse shrink-0",
    variants: {
        useGridTemplate: {
            true: "grid"
        }
    }
});

export const tableHeaderStyle = tva({
    base: "shrink-0"
});

export const tableBodyStyle = tva({
    base: "shrink-0"
});

export const tableFooterStyle = tva({
    base: "shrink-0"
});

export const tableHeadStyle = tva({
    base: "table-cell flex-1 align-middle justify-center bg-blueGray-50 first:rounded-tl-lg last:rounded-tr-lg shrink-0",
    variants: {
        size: {
            sm: "px-1.5 py-2",
            md: "px-4 py-3"
        },
        useGridTemplate: {
            true: "flex"
        }
    }
});

export const tableHeadContentStyle = tva({
    base: "shrink-0",
    variants: {
        align: {
            start: "items-start",
            center: "items-center",
            end: "items-end"
        }
    }
});

export const tableRowStyleStyle = tva({
    base: "table-row w-full group shrink-0",
    variants: {
        type: {
            footer: "",
            header: ""
        },
        isFooterRow: {
            true: "border-b-0 "
        },
        useGridTemplate: {
            true: "contents"
        }
    }
});

export const tableCellStyle = tva({
    base: `
        flex-1
        table-cell
        border-b
        border-solid
        border-blueGray-200
        align-middle
        justify-center
        group-hover:bg-blueGray-50
        shrink-0
    `,
    variants: {
        size: {
            sm: "px-1.5 py-2",
            md: "px-4 py-4"
        },
        useGridTemplate: {
            true: "flex"
        }
    }
});

export const tableCellContentStyle = tva({
    base: "min-h-[auto]",
    variants: {
        align: {
            start: "items-start",
            center: "items-center",
            end: "items-end"
        },
        visibleOnHover: {
            true: 'opacity-0 group-hover:opacity-100 web:has-[[aria-expanded="true"]]:opacity-100 web:[@media(hover:none)]:opacity-100'
        }
    }
});

export const tableCaptionStyle = tva({
    base: `${captionTableStyle} shrink-0 px-6 py-[14px] text-[16px] font-normal leading-[22px] text-typography-800 bg-background-50 font-roboto`
});
